module.exports = __webpack_public_path__ + "static/media/shoulders3.5442c5fa.png";